export function onDownloadClick(
    signatureStatus?: string,
    signedDocUrl?: string,
) {
    switch (signatureStatus) {
        case 'SignatureValid':
            window.open(signedDocUrl, '_blank');
            break;
        case 'SignatureInvalid':
            alert(
                'We found a document but the signature is invalid. That probably means the document has been tampered with.',
            );
            break;
        case 'Unsigned':
        default:
            alert('No signed document found.');
    }
}
